/* Native Shopify search URLs keep the query, filters, and locale together. */
(() => {
  function setupLanguageReturn(scope = document) {
    scope.querySelectorAll('#TOLanguage').forEach(form => {
      if (form.dataset.smReturnReady) return;
      form.dataset.smReturnReady = 'true';
      form.addEventListener('submit', event => {
        const returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) return;
        returnTo.value = location.pathname + location.search;
        const selected = event.submitter?.value;
        if (['/pages/event-registration', '/en/pages/event-registration'].includes(location.pathname)
            && event.submitter?.name === 'language_code' && ['id', 'en'].includes(selected)) {
          const url = new URL(location.href);
          url.searchParams.set('lang', selected);
          returnTo.value = url.pathname + url.search;
        }
      }, true);
    });
  }
  function setupLiveSearch(scope = document) {
    scope.querySelectorAll('[data-sm-live-search]').forEach(shell => {
      if (shell.dataset.smSearchReady) return;
      shell.dataset.smSearchReady = 'true';
      const input = shell.querySelector('input[name="q"]');
      const form = shell.querySelector('form');
      const panel = shell.querySelector('.sm-search-suggestions');
      const results = shell.querySelector('[data-sm-suggest-results]');
      const all = shell.querySelector('[data-sm-search-all]');
      let timer;
      let request;
      const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
      const search = async term => {
        request?.abort();
        request = new AbortController();
        try {
          const url = new URL(shell.dataset.suggestUrl, location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          url.searchParams.set('section_id', 'predictive-search');
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Search suggestions unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const links = [...html.querySelectorAll('#predictive-search-results-products-list a[href]')];
          if (input.value.trim() !== term) return;
          results.replaceChildren();
          if (links.length) {
            links.forEach(link => {
              const url = new URL(link.getAttribute('href'), location.origin);
              if (url.origin !== location.origin) return;
              const row = document.createElement('a');
              row.className = 'sm-suggest-product';
              row.href = url.pathname + url.search;
              const sourceImage = link.querySelector('img');
              if (sourceImage) {
                const image = document.createElement('img');
                image.src = sourceImage.src;
                image.alt = '';
                image.width = 64;
                image.height = 64;
                row.append(image);
              }
              const name = document.createElement('span');
              name.className = 'sm-suggest-name';
              name.textContent = link.querySelector('.predictive-search__item-heading')?.textContent?.trim() || '';
              row.append(name);
              const priceText = link.querySelector('[data-sm-price]')?.textContent?.trim();
              if (priceText) {
                const price = document.createElement('span');
                price.className = 'sm-suggest-price';
                price.textContent = priceText;
                row.append(price);
              }
              results.append(row);
            });
          } else {
            const empty = document.createElement('p');
            empty.className = 'sm-suggest-empty';
            empty.textContent = shell.dataset.emptyText || 'No matching products';
            results.append(empty);
          }
          open();
        } catch (error) {
          if (error.name !== 'AbortError') close();
        }
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        request?.abort();
        const term = input.value.trim();
        if (!term) { close(); results.replaceChildren(); return; }
        timer = setTimeout(() => search(term), 180);
      });
      input.addEventListener('focus', () => { if (input.value.trim() && results.childElementCount) open(); });
      shell.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); input.focus(); } });
      document.addEventListener('pointerdown', event => { if (!shell.contains(event.target)) close(); });
      form.addEventListener('submit', () => { if (!input.value.trim()) input.value = '*'; });
      all.addEventListener('click', () => { if (!input.value.trim()) input.value = '*'; });
    });
  }
  function setupResults(scope = document) {
    scope.querySelectorAll('[data-sm-results]').forEach(page => {
      if (page.dataset.smResultsReady) return;
      page.dataset.smResultsReady = 'true';
      page.querySelector('.sm-results-query')?.addEventListener('submit', event => {
        const input = event.currentTarget.querySelector('input[name="q"]');
        if (!input.value.trim()) input.value = '*';
      });
    });
  }
  setupLanguageReturn(); setupLiveSearch(); setupResults();
  document.addEventListener('shopify:section:load', event => { setupLanguageReturn(event.target); setupLiveSearch(event.target); setupResults(event.target); });
})();
